import script from "./group-fieldset-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./group-fieldset-component.vue?vue&type=script&setup=true&lang=ts"

import "./group-fieldset-component.vue?vue&type=style&index=0&id=af9aa8dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9aa8dc"]])

export default __exports__